import React, { useEffect, useRef, useState } from "react";
import IndicatorIcon from "../../components/IndicatorIcon";
import jmif from "../../image/jmif.jpg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

function JmifHistory() {
  const paragraphRef = useRef(null);
  const [truncatedText, setTruncatedText] = useState("");
  const isMobile = window.innerWidth < 1024;

  return (
    <>
      <div className="relative laptopSm:bg-white bg-secondary-lightActive laptopSm:mt-28 mt-24">
        <div className="font-montserrat bg-secondary-dark rounded-e-xl laptopSm:rounded-none laptopSm:w-[29%] inline-block md:pl-16 pl-8 pr-8 laptopSm:pr-4 laptopSm:py-20 py-2  laptopSm:absolute relative laptopSm:-top-16 top-[-40px] shadow-custom z-10 laptopSm:h-full laptopSm:text-right">
          <span className="font-bold text-xl md:text-2xl laptopSm:text-3xl text-secondary-lightActive text-nowrap">
            The History of
          </span>
          <h6 className="font-bold text-3xl md:text-[40px] laptopSm:text-[64px] text-white">
            JMIF
          </h6>
        </div>
        <div className="laptopSm:w-[80%] w-full bg-secondary-lightActive responsive-padding mt-[-15px] laptopSm:mt-0 mb-8 float-end laptopSm:py-4 laptopSm:pl-[15%] flex flex-col items-center ">
          <Carousel
            additionalTransfrom={0}
            arrows={false}
            autoPlaySpeed={3000}
            centerMode={false}
            customButtonGroup={<IndicatorIcon />}
            className=""
            containerClass="w-full"
            dotListClass=""
            draggable={isMobile}
            focusOnSelect={false}
            infinite
            itemClass="px-2"
            keyBoardControl
            minimumTouchDrag={80}
            pauseOnHover
            renderArrowsWhenDisabled={false}
            renderButtonGroupOutside={true}
            renderDotsOutside={false}
            responsive={{
              desktop: {
                breakpoint: {
                  max: 3000,
                  min: 1024,
                },
                items: 1,
              },
              mobile: {
                breakpoint: {
                  max: 464,
                  min: 0,
                },
                items: 1,
              },
              tablet: {
                breakpoint: {
                  max: 1023,
                  min: 464,
                },
                items: 1,
              },
            }}
            rewind={false}
            rewindWithAnimation={false}
            rtl={false}
            shouldResetAutoplay
            showDots={false} // Disable default dots since we're using custom indicators
            sliderClass=""
            slidesToSlide={1}
            swipeable
          >
            {/* page 1 */}
            <div className="h-full flex flex-col justify-center">
              <p
                ref={paragraphRef}
                className="text-grey-normal font-light text-xs md:text-sm laptopLg:text-base leading-6 tracking-[0.06em] text-justify indent-10 text-pretty"
              >
                Jamiatu Marawi Al-Islamia Foundation (JMIF) is a sectarian,
                non-profit, non-stock Islamic Institution and a Madrasah (Arabic
                word for school) system of education. It was conceived in 1970
                and formally established in January 1972 operating the Ibtidae
                (Primary), Edade (Elementary), Thanawi/Sanawi (High School) and
                Kulya (College) with the name MAAHAD MARAWI AL-ISLAMIE at the
                ground floor of Dansalan Mosque, Quezon Avenue, Marawi City.
              </p>

              <div className="w-full h-[235px] laptop:h-[304px] border-4 border-white rounded-[20px] mt-6">
                <img
                  src={jmif}
                  alt={jmif}
                  className="w-full h-full object-cover object-center rounded-[20px]"
                />
              </div>
              <p className="md:hidden text-grey-normal font-light text-xs md:text-sm laptopLg:text-base leading-6 tracking-[0.06em] text-justify indent-10 text-pretty mt-6">
                The Maahad was organized by a Muslim religious group headed by
                Sultan Rashid D. Sampaco, who at the same time financially
                supported it. The other members were Aleem Basher Edres, Aleem
                Zainoden Bato, Aleem Edris Mindalano, Aleem Ibrahim Abdulrahman,
                Aleem Ansari Mutia, Aleem Olumuddin Said, Aleem Madki Magangkong
                and Aleem Moctar Abedin.
              </p>
            </div>
            {/* page 2 */}
            <div className="h-full flex flex-col md:flex-row items-center justify-center gap-x-8 gap-y-4">
              <div className=" md:w-2/5">
                <div className="w-full h-[235px] laptop:h-[304px] border-4 border-white rounded-[20px] mt-6">
                  <img
                    // src="image/grad-pic.jpg"
                    alt="sultan rashid sampaco"
                    className="w-full h-full object-cover object-center rounded-[20px]"
                  />
                </div>

                <div className=" w-full flex items-center justify-center mt-2">
                  <p className="font-notoSans font-light italic text-xs text-center">
                    Sultan Rashid D. Sampaco
                  </p>
                </div>
              </div>
              <p className=" md:w-[80%] text-grey-normal font-light text-xs md:text-sm laptopLg:text-base leading-6 tracking-[0.06em] text-justify text-pretty">
                <span className="hidden text-justify indent-10 md:inline md:block">
                  The Maahad was organized by a Muslim religious group headed by
                  Sultan Rashid D. Sampaco, who at the same time financially
                  supported it. The other members were Aleem Basher Edres, Aleem
                  Zainoden Bato, Aleem Edris Mindalano, Aleem Ibrahim
                  Abdulrahman, Aleem Ansari Mutia, Aleem Olumuddin Said, Aleem
                  Madki Magangkong and Aleem Moctar Abedin.
                </span>
                They later on become the Board of Trustees of the Maahad.
                However, when Aleem Edris Mindalano and Aleem Moctar Abedin
                died, only seven (7) members of the Board of Trustees managed
                the school. The primary aim of the Maahad was to answer the need
                of the less privileged but deserving out-of-school youth in
                Marawi City and Lanao del Sur. Since then, Maahad had sent
                hundreds of scholars to the Middle East Countries, who now
                become Ulama and Ustadz or Missionaries in Muslim areas in the
                country. After the demise of its founding president in 2006, his
                eldest son Sultan Nasser D. Sampaco, CPA, MM, Chairman of the
                Marawi Sultanate League, assumed of the position of the
                President and Chairman of the Board of Trustees since 20026 to
                present.
              </p>
            </div>
            {/* page 3 */}
            <div className="h-full flex flex-col justify-center">
              <div className="w-full h-[235px] border-4 border-white rounded-[20px] ">
                <img
                  src={jmif}
                  alt={jmif}
                  className="w-full h-full object-cover object-center rounded-[20px]"
                />
              </div>
              <p
                ref={paragraphRef}
                className="text-grey-normal font-light text-xs md:text-sm laptopLg:text-base leading-6 tracking-[0.06em] text-justify indent-10 text-pretty mt-6"
              >
                A four-hectare land located at Upper Marinaut, Marawi City owned
                by the late Datu Sampaco Gubat and Shiek Pandao Tubac was
                donated in 1991, by their heirs to Maahad Marawi Al-Islamie.
                This donated lot becomes the main campus of what is now Jamiatu
                Marawi Al-Islamia Foundation. A three-storey concrete academic
                building consisting of thirty two (32) classrooms,
                administrative offices, a library, a canteen, a laboratory room
                and a CAT/NSTP room was constructed through the financial
                assistance of the Islamic Development Bank (IDB) headed by its
                President Dr. Ahmad Muhammad Ali and Jamiatu Iqra Al-Khairia
                (Charitable Arabic Society) headed by Dr. Muhammad Yamani, its
                President.
              </p>
            </div>
            {/* page 4 */}
            <div className="h-full flex flex-col justify-center">
              {" "}
              <p
                ref={paragraphRef}
                className="text-grey-normal font-light text-xs md:text-sm laptopLg:text-base leading-6 tracking-[0.06em] indent-10 text-justify text-pretty"
              >
                In 1994, Maahad Marawi Al-Islamie, in response to public request
                sought government recognition and started to offer academic
                programs prescribed by DepEd and CHED but enriched with course
                contents in Arabic and Islamic Studies. It also changed its name
                from a Maahad to Jamiatu Marawi Al-Islamia Foundation, Inc.
                (JMIF, Inc). In about twenty-three years under its name JMIF,
                Inc., it now offers the following academic programs.
              </p>
              <ol className="pt-4 pl-5 list-decimal text-grey-normal font-light text-xs md:text-sm laptopLg:text-base leading-loose tracking-[0.06em]  ">
                <li>Complete Kindergarten</li>
                <li> Complete Elementary Education</li>
                <li> Complete Junior High School</li>
                <li> Senior High School</li>
                <li>
                  Collegiate Courses:
                  <ol className="">
                    <li>
                      <span className="before:content-['5.1_']">
                        Bachelor of Science in Elementary Education, major in
                        General Education
                      </span>
                    </li>
                    <li>
                      <span className="before:content-['5.2_']">
                        Bachelor of Science in Secondary Education major in
                        English
                      </span>
                    </li>
                    <li>
                      <span className="before:content-['5.3_']">
                        Bachelor of Science in Nursing (BSN)
                      </span>
                    </li>
                    <li>
                      <span className="before:content-['5.4_']">
                        Bachelor of Science in Midwifery (BSM)
                      </span>
                    </li>
                  </ol>
                </li>
              </ol>
            </div>
            {/* <div>
              <IndicatorIcon />
            </div> */}
          </Carousel>
        </div>
      </div>
    </>
  );
}

export default JmifHistory;
